import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spring, animated } from 'react-spring/renderprops'; // NOTE: Needs rewrite without renderprops

import { LinkButton, TrainingText, TrainingVideo } from 'C4';

export default class RetainContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: this.props.image,
      showContent: false,
      index: 0,
      buttons: [],
    };

    this.toggleContent = this.toggleContent.bind(this);
  }

  componentDidMount() {
    this.setButtons(this.props.params);
  }

  componentDidUpdate() {
    const { image } = this.state;
    if (image !== this.props.image) {
      this.updateContent(this.props.image);
    }
  }

  updateContent(image) {
    this.setState({ image });
    this.setState({ showContent: false });
  }

  toggleContent() {
    this.setState((prevState) => ({
      showContent: !prevState.showContent,
    }));
    this.setState(({ index }) => ({ index: index === 2 ? 0 : index + 1 }));
  }

  setButtons(page) {
    console.log('ffa');
    const buttons = [];
    this.setState({ buttons });
    let index = 1;

    if (page !== undefined) {
      index = 1;
      Object.keys(page).forEach((link) => {
        console.log(link);
        const links = [page[`link${index}`], page[`linkType${index}`]].every(val => (val !== undefined && val.length > 0));
        const linksValid = (page.question === undefined && links);
        if (link === `link${index}` && linksValid) {
          buttons.push(<LinkButton
            key={page[`linkType${index}`]}
            link={page[`link${index}`]}
            type={page[`linkType${index}`]}
          />);
          index += 1;
        }
      });
      this.setState({ buttons });
    }
  }

  render() {
    const { image, showContent, index, buttons } = this.state;

    const { appId, params, summary  } = this.props;

    return (
      <div className="retain__container">
        {params.pageType === '' && (
          <Spring
            native
            keys={index}
            from={{ opacity: 0 }}
            to={{
              opacity: showContent ? 0 : 1,
              transform: showContent ? 'scale(0)' : 'scale(1)',
              display: showContent ? 'none' : 'flex',
            }}
          >
            {(styles) => (
              <animated.div className="retain__textWrapper" style={styles}>
                <div className="retain__summary">
                  <h3>{summary.title}</h3>
                  <div>{summary.text}</div>
                  <div className="retain__summary--butons">{buttons}</div>
                  <button className="readMoreBtn" onClick={this.toggleContent}>
                    {i18n.translate('trainingScreens.watchListenRead')}
                    <FontAwesomeIcon icon={['fas', 'caret-down']} />
                  </button>
                </div>
                <div className="retain__banner">
                  <img src={image} alt={image} />
                  {params.imageCredits && <h3>{params.imageCredits}</h3>}
                </div>
              </animated.div>
            )}
          </Spring>
        )}
        {params.pageType === '' && (
          <Spring
            native
            keys={index}
            to={{
              opacity: showContent ? 1 : 0,
              top: showContent ? 0 : 100,
              display: showContent ? 'block' : 'none',
            }}
          >
            {(styles) => (
              <animated.div className="retain__text" style={styles}>
                {buttons}
                <button className="btnInverse closeBtn" onClick={this.toggleContent}>
                  <FontAwesomeIcon icon={['fas', 'window-close']} />
                </button>
                <TrainingText
                  key={index}
                  pageID={params.pageID}
                  buttons={null}
                  appId={appId}
                  {...params}
                  // hideTitle
                />
              </animated.div>
            )}
          </Spring>
        )}
        {params.pageType === 'Photo' && (
          <div className="retain__photo">
            <img src={image} alt={image} />
          </div>
        )}
        {params.pageType === 'autoPlay' && (
          <div className="retain__video">
            <TrainingVideo appId={appId} {...params} />
          </div>
        )}
      </div>
    );
  }
}

RetainContent.propTypes = {
  appId: PropTypes.number.isRequired,
  summary: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.shape()]),
  }),
  image: PropTypes.string,
  params: PropTypes.shape().isRequired,
};

RetainContent.defaultProps = {
  image: PropTypes.string.isRequired,
  summary: {
    title: '',
    text: [],
  },
};
